import { useParams } from 'react-router-dom';
import { api, useTenant } from '../../lib/api';
import { dotClass } from '../../lib/status';

export default function Phases() {
  const { id = '' } = useParams();
  const { data: t } = useTenant(id);
  if (!t) return null;

  async function run(phase: string) { await api.runPhase(id, phase); }

  function duration(p: { started_at: string | null; finished_at: string | null }) {
    if (!p.started_at) return '';
    const start = new Date(p.started_at).getTime();
    const end = p.finished_at ? new Date(p.finished_at).getTime() : Date.now();
    const s = Math.round((end - start) / 1000);
    if (s < 60) return `${s}s`;
    return `${Math.floor(s/60)}m ${s%60}s`;
  }

  return (
    <div className="p-6 max-w-4xl">
      <div className="card divide-y divide-line">
        {t.phases.map(p => (
          <div key={p.phase} className="p-3 flex items-center gap-3">
            <span className={dotClass(p.status)} />
            <div className="flex-1">
              <div className="text-sm">{p.phase}</div>
              {p.error && <div className="text-xs text-err truncate">{p.error.split('\n')[0]}</div>}
            </div>
            <div className="text-xs text-dim w-16 text-right">{p.status}</div>
            <div className="text-xs text-dim w-20 text-right">{duration(p)}</div>
            <div className="text-xs text-dim w-16 text-right">att {p.attempt}</div>
            <button onClick={() => run(p.phase)} className="btn text-xs" title="Run this phase and every phase after it">
              run from here
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
